<div class="flex flex-row mt-3 mb-3">
    <div class="w-6 mr-6">
        <h4>Product Details</h4>
        <label class="mb-3">Product Name:</label>
        <p-dropdown 
            (onChange)="productChanged()"
            [options]="products"
            [(ngModel)]="productDetailsModel.selectedProduct"
            optionLabel="Name"
            placeholder="Select Product Name" />
        <label class="mb-3 mt-3">Item Identifier (e.g. Serial # or License Plate)</label>
        <input class="input-profile" 
                [(ngModel)]="productDetailsModel.serialNumber" 
                type="text" pInputText 
                placeholder="Enter a Serial # or License Plate"
                (keyup)="serialNumberChanged()">
        <div class="flex flex-wrap gap-3 mt-3 mb-3">
            <div class="flex align-items-center w-4">
                <p-radioButton 
                    name="pizza" 
                    [value]="1" 
                    (ngModelChange)="paymentChanged()"
                    [(ngModel)]="productDetailsModel.payment" 
                    inputId="free" />
                <label for="free" class="ml-2">
                    Free
                </label>
            </div>
            
            <div class="flex align-items-center w-4">
                <p-radioButton 
                    name="pizza" 
                    [value]="2"
                    [disabled]="true"
                    (ngModelChange)="paymentChanged()"
                    [(ngModel)]="productDetailsModel.payment" 
                    inputId="paid" />
                <label for="paid" class="ml-2">
                    Paid
                </label>
            </div>
            
            <div class="flex align-items-center">
                <p-radioButton 
                    name="pizza" 
                    [value]="3" 
                    (ngModelChange)="paymentChanged()"
                    [(ngModel)]="productDetailsModel.payment" 
                    inputId="repayment" />
                <label for="repayment" class="ml-2">
                    Repayment
                </label>
            </div>
        </div>
        <div class="flex flex-row">
            <div class="w-6 mr-2">
                <p>Product Price:</p>
                <span class="product-price">
                    {{(productDetailsModel.selectedProduct.Price ? productDetailsModel.selectedProduct.Price : 0) | currency: 'PHP' : 'symbol' : '1.2-2'}}
                </span>
            </div>
            <div class="w-6">
                <p>Security Bond:</p>
                <span class="product-price">
                    {{(productDetailsModel.selectedProduct.SecurityBondAmount ? productDetailsModel.selectedProduct.SecurityBondAmount : 0) | currency: 'PHP' : 'symbol' : '1.2-2'}}
                </span>
            </div>
        </div>
    </div>
    <div class="w-6">
        <label class="mb-3">Upload Product Images:</label>
        <p-panel>
            <ng-template pTemplate="header">
                <div>
                    <input #productImage multiple style="display: none" type="file" accept=".png, .jpg" (change)="handleImageChange($event)">
                    <p-button [disabled]="productDetailsModel.files.length > 0" class="mr-2 add-product-next-btn" label="Choose" icon="pi pi-plus" (onClick)="productImage.click()"></p-button>
                </div>
                <p-button class="add-product-cancel-btn" label="Remove All" icon="pi pi-times" severity="danger" (onClick)="removeImages()"></p-button>
            </ng-template>
            <ng-template pTemplate="body">
                <p-scrollPanel [style]="{ width: '100%', height: '150px' }">
                    <div appDnd (fileDropped)="handleImageChange($event)">
                        <p *ngIf="productDetailsModel.imageUrl.length === 0 && fileErrorMessage.length === 0">Drag and Drop files here to upload.</p>
                        <div *ngIf="!uploadInProgress && productDetailsModel.imageUrl && fileErrorMessage.length === 0">
                                <div *ngFor="let image of productDetailsModel.imageUrl; let i = index" class="mb-1 flex justify-content-between">
                                    <div>
                                        <img src="{{image}}" width="80px" alt="file" />
                                    </div>
                                    <div>
                                        <span>{{productDetailsModel.files[i].name}}</span>
                                    </div>
                                    <div>
                                        <span>{{productDetailsModel.files[i].size | filesize}}</span>
                                    </div>
                                    <div>
                                        <p-button class="add-product-next-btn" icon="pi pi-times" (onClick)="removeImages(i)" />
                                    </div>
                                </div>
                        </div>
                        <p-messages *ngIf="fileErrorMessage" [(value)]="fileErrorMessage" [enableService]="false"></p-messages>
                    </div>
                </p-scrollPanel>
            </ng-template>
        </p-panel>
        <p class="mt-3 upload-note">You can upload up to 6 images of the product. Don't forget to include photos that show the serial number or any unique identifiers.</p>
        <p class="upload-warning">Accepted Files: .png, .jpg</p>
    </div>
</div>
<hr>
<h4>Penalties</h4>
<div class="flex flex-row justify-content-between pr-4 pb-3">
    <div class="flex flex-column w-6">
        <div class="mb-3">
            Penalty cut-off:
        </div>
        <div>
            {{(productDetailsModel.selectedProduct.PenaltyCutOffDays ? productDetailsModel.selectedProduct.PenaltyCutOffDays + ' Days' : '-')}}
        </div>
    </div>
    <div class="flex flex-column w-6 mr-2">
    </div>
    <div class="flex flex-column w-6">
        <div class="mb-3">
            Collection cut-off:
        </div>
        <div>
            {{(productDetailsModel.selectedProduct.DaysBeforeCollection ? productDetailsModel.selectedProduct.DaysBeforeCollection + ' Days' : '-')}}
        </div>
    </div>
</div>